import { Route, Routes } from "react-router-dom";//The Routes component is used to group multiple Route and route is used for mapping between a specific URL path and the component.
import Navbar from "./components/Views/Logic/Navbar";
import { useEffect, useRef, useState } from 'react'
import { findAllChapters, findAllTranslatorScriptsReciters } from './apis/FetchData';
import "./assets/css/main.css";
import "./assets/css/fonts.css";
import './assets/css/bootstrap.min.css';
import './assets/css/mystyles.css';
import './assets/css/readstyle.css';
import './assets/css/dropdown.css';
import './assets/css/login.css';
import './assets/css/custom-theme.scss';
import './assets/css/theme_custom_changes.css';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { ChaptersReducer } from "./redux/AllChapter"
import Home from "./components/Views/Logic/Home/Home"
import Search from "./components/Views/Logic/Search";
import Collections from "./components/Views/Logic/AllCollections/AllCollections";
import CollectionDetails from "./components/Views/Logic/AllCollections/CollectionDetails";
import Bookmarks from "./components/Views/Logic/Bookmarks/AllBookmarks";
import Notes from "./components/Views/Logic/Notes/Notes";
import ProtectedRoute from "./components/ProtectedRoute";
import AudioBar from "./components/Views/Logic/AudioBar";


const ChapterActions = ChaptersReducer.actions;

function App() {

  // useSelector((state) => state.chapters);
  const chapters = useSelector((state) => state.chapters);
  let userTheme = useSelector((state) => state.settings.userTheme);
  const dispatch = useDispatch()//uses the useDispatch hook from the react-redux library to get the dispatch function from the Redux store
  const location = useLocation();
  const [selectedSurah, setselectedSurah] = useState(1);
  let [selectedVerse, setselectedVerse] = useState(1);
  const audioBarRef = useRef(null);
  const isFetchingRef = useRef(false);

  if (userTheme==='Auto')
  {
    userTheme='Light'
  }
  const fetchData = async () => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    try {
      if (chapters.chapters.length === 0) {

        let chaptersResult = await findAllChapters();
        if (chaptersResult.status)
          dispatch(
            ChapterActions.updateChapterList({ chapters: chaptersResult.data })
          );
      }
      if (chapters.reciters.length === 0 || chapters.scripts.length === 0 || chapters.translators.length === 0) {
        let chaptersResult = await findAllTranslatorScriptsReciters();
        if (chaptersResult.status) {
          dispatch(
            ChapterActions.updateRecitersList({
              reciters: chaptersResult.data.reciters,
            })
          );
          dispatch(
            ChapterActions.updateScriptsList({
              scripts: chaptersResult.data.scripts,
            })
          );
          dispatch(
            ChapterActions.updateTranslatorsList({
              translators: chaptersResult.data.translators,
            })
          );
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // fetchData is stable and should only run once on mount


  useEffect(() => {
    const chapterRouteMatch = location.pathname.match(/^\/(\d+)\/(\d+)\/?$/);
    if (chapterRouteMatch) {
      setselectedSurah(parseInt(chapterRouteMatch[1], 10));
      setselectedVerse(parseInt(chapterRouteMatch[2], 10));
    } else if (location.pathname === "/") {
      setselectedSurah(1);
      setselectedVerse(1);
    }
  }, [location]);

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', userTheme);
  }, [userTheme]);

  return (

    <div>
      <Navbar  selectedSurah={selectedSurah} selectedVerse={selectedVerse} />
      <div className="body">
        <Routes>
          <Route path="/" element={<Home  selectedSurah={selectedSurah} selectedVerse={selectedVerse} audioBarRef={audioBarRef} />} />
          <Route path=":surah/:verse" element={<Home   selectedSurah={selectedSurah} selectedVerse={selectedVerse} audioBarRef={audioBarRef} />} />               
          <Route path="/search" element={<Search  userTheme={userTheme} />} />
          <Route path="/search/:searchKeyword" element={<Search  userTheme={userTheme} />} />
          <Route path="/search/rootword/:searchKeyword?" element={<Search  userTheme={userTheme} />} />
          <Route path="/collections" element={<ProtectedRoute><Collections  userTheme={userTheme} /></ProtectedRoute>} />
          <Route path="/collection-detail/:collectionId" element={<ProtectedRoute><CollectionDetails  userTheme={userTheme} /></ProtectedRoute>} />
          <Route path="/bookmarks" element={<ProtectedRoute><Bookmarks  userTheme={userTheme} /></ProtectedRoute>} />
          <Route path="/notes" element={<ProtectedRoute><Notes  userTheme={userTheme} /></ProtectedRoute>} />



        </Routes>
      </div>
      <AudioBar ref={audioBarRef} currentSurah={selectedSurah} currentVerse={selectedVerse} />
    </div>

  );
}

export default App;
